// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xZw4ox4hfScAbw {
  padding-top: var(--ds-space-200, 16px);
  background-color: var(--ds-surface, #ffffff);
}
.xZw4ox4hfScAbw.ZkzcZwKp8R98vQ {
  padding-top: var(--ds-space-600, 48px);
}
.JAhhEdV0JLOlQh {
  position: sticky;
  z-index: 1;
  top: var(--ds-space-0, 0);
}
.FvGK1GmWhXPve4 {
  margin-bottom: var(--ds-space-200, 16px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `xZw4ox4hfScAbw`,
	"fullscreen": `ZkzcZwKp8R98vQ`,
	"sticky": `JAhhEdV0JLOlQh`,
	"title": `FvGK1GmWhXPve4`
};
export default ___CSS_LOADER_EXPORT___;
